import Image from "@components/_shared/NextImage/v2";
import { useSiteConfig } from "@context/siteConfig";
import { useTranslations } from "@context/translations";
import clsx from "clsx";
import styles from "./About.module.scss";

interface AboutProps {
  isDarkTheme?: boolean;
}

const About: React.FC<AboutProps> = ({ isDarkTheme }) => {
  const translate = useTranslations();
  const { isRtl } = useSiteConfig();

  const createMarkup = (html: string) => {
    return { __html: html };
  };

  const illustrationImagePrefix = isDarkTheme ? "-dark" : "";

  return (
    <div
      className={clsx(
        styles.container,
        isRtl && styles.rtl,
        isDarkTheme && styles.dark
      )}
    >
      <div className={styles.hero}>
        <div className={styles.heroFilter}></div>

        <div className={clsx(styles.titleContainer, isRtl && styles.rtl)}>
          <div className={styles.title}>{translate("about_title")}</div>

          <div className={styles.text}>{translate("about_sub_title")}</div>
        </div>
      </div>

      <div className={styles.main}>
        <div className={styles.even}>
          <div className={styles.logo}>
            <Image
              src={`https://zen.shopcash.com/assets/static/illustrations/wego-shopcash${illustrationImagePrefix}.png`}
              alt="Wego and ShopCash Logos"
              width={300}
              height={300}
            />
          </div>

          <div className={styles.content}>
            <div className={styles.title}>
              {translate("about_section1_header")}
            </div>
            <p
              dangerouslySetInnerHTML={createMarkup(
                translate("about_section1_description")
              )}
            />
          </div>
        </div>

        <div className={styles.logo}>
          <Image
            src={`https://zen.shopcash.com/assets/static/illustrations/idea${illustrationImagePrefix}.png`}
            alt="Idea Logos"
            width={300}
            height={300}
          />
        </div>

        <div className={styles.content}>
          <div className={styles.title}>
            {translate("about_section2_header")}
          </div>

          <p
            dangerouslySetInnerHTML={createMarkup(
              translate("about_section2_description")
            )}
          />
        </div>

        <div className={styles.even}>
          <div className={styles.logo}>
            <Image
              src={`https://zen.shopcash.com/assets/static/illustrations/team${illustrationImagePrefix}.png`}
              alt="Team Logos"
              width={300}
              height={300}
            />
          </div>

          <div className={styles.content}>
            <div className={styles.title}>
              {translate("about_section3_header")}
            </div>

            <p
              dangerouslySetInnerHTML={createMarkup(
                translate("about_section3_description")
              )}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
